import { csx } from '@vtex/admin-ui'

const styles = {
  container: csx({
    padding: '$space-4 $space-5',
    border: '$neutral',
    borderRadius: 4,
    width: '100%',
    background: 'white',
    gap: '$space-3',
    '> button': {
      marginLeft: 'auto',
    },
    '> button:not([aria-expanded="true"])': {
      opacity: 0,
    },
    ':hover': {
      '> button': {
        opacity: 1,
      },
    },
  }),
}

export default styles
